const environment = {
  production: true,
  api_url: 'https://app.levitup.com/_',
  oauth2_client_id: 'web',
  oauth2_client_secret: 'TpeiOADVCd',
  session_encrypt_key: 'BUXSeN0L@g8O',
  default_locale: 'es-ES'
};

export default environment;